export default {
  setup: {},
  loading: false
};
